"use client";

import { HeroTextSection } from "./hero-text-section";
import { useTrackWhenInView } from "@/hooks/useTrackWhenInView";
import { ReportAssetFrame } from "../../../../pages/landing-assets/report/ReportAssetFrame";
import { QuestionnaireAssetFrame } from "../../../../pages/landing-assets/questionnaire/QuestionnaireAssetFrame";
import { BlurFade } from "@/components/ui/blur-fade";

export function HeroSection() {
  const ref = useTrackWhenInView<HTMLElement>("hero_section_visible");

  return (
    <main
      ref={ref}
      className="flex flex-col items-center justify-between px-4 py-6 lg:h-[calc(100vh_-_60px)] lg:flex-row lg:px-[60px] lg:pt-0"
    >
      <HeroTextSection />

      <div className="mt-[56px] lg:mt-0 lg:max-h-full lg:w-2/5 lg:pl-[60px]">
        <BlurFade delay={2}>
          <div className="flex size-full flex-1">
            <div>
              <ReportAssetFrame />
            </div>
            <div className="-ml-[15%] mt-[20%]">
              <QuestionnaireAssetFrame />
            </div>
          </div>
        </BlurFade>
      </div>
    </main>
  );
}
